import axios from '../../../../../redux/my-axios';

export const DELIVERIES_URL = '/deliveries';

export function findDeliveries(queryParams) {
  return axios.post(DELIVERIES_URL, queryParams, {
    headers: { action: 'find' },
  });
}

export function getDeliver(deliverCode) {
  return axios.post(DELIVERIES_URL, deliverCode, {
    headers: { action: 'get' },
  });
}

export function createDeliver(deliver) {
  return axios.post(DELIVERIES_URL, deliver, { headers: { action: 'post' } });
}
export function updateDeliver(deliverForView) {
  return axios.post(DELIVERIES_URL, deliverForView, {
    headers: { action: 'put' },
  });
}

export function deleteDeliver(deliverCode) {
  return axios.post(DELIVERIES_URL, deliverCode, {
    headers: { action: 'delete' },
  });
}
